import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeadsetCursor from "@/components/HeadsetCursor";
import { Link } from "react-router-dom";

export default function PublicShell({ eyebrow, title, sub, children, testid }) {
  return (
    <div className="min-h-screen bg-white text-[#111111] antialiased" data-testid={testid}>
      <HeadsetCursor />
      <Header />
      <main>
        <section className="border-b border-neutral-100 py-16 sm:py-24">
          <div className="mx-auto max-w-4xl px-5 sm:px-8">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-400">{eyebrow}</p>
            <h1 className="mt-4 text-4xl font-extrabold tracking-tight sm:text-5xl">{title}</h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-neutral-500 sm:text-lg">{sub}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to="/signup"
                data-testid={`${testid}-cta`}
                className="rounded-full bg-[#111111] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-neutral-800"
              >
                Get Started
              </Link>
              <Link
                to="/#pricing"
                className="rounded-full border border-neutral-300 px-6 py-3 text-sm font-semibold text-[#111111] transition-colors hover:bg-neutral-50"
              >
                See Pricing
              </Link>
            </div>
          </div>
        </section>
        {children}
      </main>
      <Footer />
    </div>
  );
}

export function Block({ title, children, testid }) {
  return (
    <section className="border-b border-neutral-100 py-12 sm:py-16" data-testid={testid}>
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <h2 className="text-2xl font-extrabold tracking-tight sm:text-3xl">{title}</h2>
        <div className="mt-6">{children}</div>
      </div>
    </section>
  );
}

export function SampleNote() {
  return (
    <span className="ml-2 rounded-full border border-neutral-200 bg-neutral-50 px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-neutral-400">
      Sample data
    </span>
  );
}
